import { useSetRecoilState } from 'recoil';
import { workspaceDisplayArrangementState } from './state';
import { getWorkspaceLayoutSnapshot } from './getWorkspaceLayoutSnapshot';
import { useEffect } from 'react';
import { getIndexedDisplays, buildDisplaySlots } from './utils';
import { logger } from 'modules/logger';
import {
  addExtensionListener,
  removeExtensionListener,
} from 'domains/extension/extensionEventCreators';
import { RESPONSE_EVENTS } from 'domains/extension/constants';

export function useWorkspaceDisplayArrangement() {
  const setWorkspaceDisplayArrangement = useSetRecoilState(workspaceDisplayArrangementState);

  useEffect(() => {
    const capture = async () => {
      try {
        const snapshot = await getWorkspaceLayoutSnapshot();
        const displays = getIndexedDisplays(snapshot.displays);
        logger.info(
          '[WorkspaceLayoutManager] Display change detected, capturing workspace layout arrangement.',
          { displays }
        );
        setWorkspaceDisplayArrangement({ displays: buildDisplaySlots(displays) });
        setWorkspaceDisplayArrangement({ displays: buildDisplaySlots(displays) });
      } catch (error) {
        logger.warn('[WorkspaceLayoutManager] Failed to capture display arrangement', error);
      }
    };
    capture();

    addExtensionListener(RESPONSE_EVENTS.DISPLAY_CHANGED, capture);
    return () => removeExtensionListener(RESPONSE_EVENTS.DISPLAY_CHANGED, capture);
  }, [setWorkspaceDisplayArrangement]);
}
